import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import {
    type NodeCfg,
} from '../nodes';
import { functionalItem } from './functional-select.zod';

export const functionalOutputsNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('functionalOutputs'),
    controlValues: z.object({
        outputs: z.array(functionalItem),
    }),
});
export type FunctionalOutputsNodeCfgSchema = z.infer<typeof functionalOutputsNodeCfgSchema>;

export const functionalOutputsNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            finish: 'event',
        }),
        outputs: () => ({}),
    },
    dataSockets: {
        inputs: (cfg: NodeCfg<'functionalOutputs'>): Record<`input${number}`, 'string' | 'number' | 'boolean'> => {
            const ret = cfg.controlValues.outputs.reduce((acc, curr, i) => {
                acc[`input${i}`] = curr.dataType;
                return acc;
            }, {} as Record<`input${number}`, 'string' | 'number' | 'boolean'>);
            return ret;
        },
        outputs: () => ({}),
    },
} satisfies NodeSocketCfg<FunctionalOutputsNodeCfgSchema>;
